export const INVOICES_KEY = ["invoices"];
